var editFirmware = (function () {
  const init = function () {
    var byteArray = [];
    document.getElementById("FirmwareFile").addEventListener(
      "change",
      function () {
        var reader = new FileReader();
        reader.onload = function () {
          var arrayBuffer = this.result,
            array = new Uint8Array(arrayBuffer);
          byteArray = Array.from(array);
          document.getElementById("firmware-size").innerHTML = `${Math.round(
            byteArray.length / 1024
          )} kB`;
        };
        reader.readAsArrayBuffer(this.files[0]);
      },
      false
    );

    $(".remove-component-button").each(function () {
      $(this).on("click", function () {
        $(this).parent().remove();
      });
    });

    $("#edit-hardware-button").on("click", function () {
      const $dropdownList = $(this).parents(".dropdown-list");
      $dropdownList.append(buildAdditionalDropdown($dropdownList));
    });

    $("#edit-bootloader-button").on("click", function () {
      const $dropdownList = $(this).parents(".dropdown-list");
      $dropdownList.append(buildAdditionalDropdown($dropdownList));
    });

    setupComponentSelector(
      "#add-hardware-dropdown",
      ".hardware-dropdown",
      "#SelectedHardwareIdValidation"
    );
    setupComponentSelector(
      "#add-bootloader-dropdown",
      ".bootloader-dropdown",
      "#SelectedBootloaderIdValidation"
    );

    function setupComponentSelector(componentId, selectCss, errorId) {
      $(componentId).click(function () {
        const $dropdownList = $(this).parents(".dropdown-list");
        $dropdownList.append(buildAdditionalDropdown($dropdownList));
      });
      $(selectCss).change(function () {
        $(errorId).hide();
      });
    }

    function buildAdditionalDropdown($dropdownList) {
      const $additionalDropdown = $(
        '<div class="additional-dropdown"></div>'
      ).append($dropdownList.find(".dropdown select").clone());

      const $removeIcon = $(
        '<i class="mdi mdi-close-circle-outline remove-component-button"></i>'
      ).on("click", function () {
        $(this).parent().remove();
      });

      $additionalDropdown.find("select").after($removeIcon);
      return $additionalDropdown;
    }

    $("#edit-firmware-button").on("click", function () {
      if (validate() === false) {
        return;
      }

      const editViewModel = {
        Id: $("#Id").val(),
        Version: $("#Version").val(),
        Description: $("#Description").val(),
        File: byteArray,
        SelectedHardwareIds: selectValues($(".hardware-dropdown")),
        SelectedBootloaderIds: selectValues($(".bootloader-dropdown")),
      };

      $.ajax({
        url: "/Firmwares/Edit",
        method: "POST",
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        data: JSON.stringify(editViewModel),
      }).done(function (data) {
        if (data.success) {
          $.notificationSuccess(data.header, data.message);
          setTimeout(function () {
            document.location = "/Firmwares/Index";
          }, reloadDelay);
        } else {
          $.notificationAlert(data.header, data.message);
        }
      });

      function validate() {
        var isValid = true;
        $(".validation").hide();
        if (!hasValue($("#Version"))) {
          $("#VersionValidation").show();
          isValid = false;
        }

        if (!hasAtLeastOneValue($(".hardware-dropdown"))) {
          $("#SelectedHardwareIdValidation").show();
          isValid = false;
        }
        if (!hasAtLeastOneValue($(".bootloader-dropdown"))) {
          $("#SelectedBootloaderIdValidation").show();
          isValid = false;
        }

        return isValid;
      }

      function hasValue($field) {
        return $field.val() ? $field.val().length !== 0 : false;
      }

      function hasAtLeastOneValue($inputs) {
        var iterator = 0;
        $inputs.each(function () {
          if (hasValue($(this))) {
            iterator++;
          }
        });
        return iterator > 0;
      }
    });

    function selectValues($inputs) {
      var values = [];
      $inputs.each(function () {
        const value = $(this).val();
        if (value) {
          values.push(value);
        }
      });
      return values;
    }
  };

  return {
    init: init,
  };
})();
